import { Component, EventEmitter, Input, Output} from "@angular/core";
import { Router } from "@angular/router";
import { AppSettings } from "../settings/app.settings";
import { StringExtensions } from "../utilities/string.extensions";
import { AppRoutes } from "../settings/routes";
import { Location } from "../utilities/location";
import { MiscService } from "../services/misc.service";

@Component({
	selector: "cortexredirector",
  template: `


<!-- show just the button without the explination text -->
<ng-template [ngIf]="buttonOnly">
  <a class="btn btn-default" target="_blank" (click)="redirectToCortex()" data-autmoation-continue-in-cortex-button>
      <i class="fas fa-external-link-alt" aria-hidden="true">
      </i> Continue in Cortex</a>
</ng-template>

<!-- the explination text saying "under construction" w/the button -->
<ng-template [ngIf]="!buttonOnly">
  <div class="border-bottom margin-bottom-sm ">
		<h3>{{title}}</h3>
</div>
<div class="row">
		<div class="col-sm-6">

			<p class="font-size-xs text light margin-bottom-sm">
				The section you are trying to access is not available yet.
				Meanwhile, you can continue the process by taking a detour and going outside of SampleOne:
			</p>

			<a class="btn btn-default" target="_blank" (click)="redirectToCortex()" data-autmoation-continue-in-cortex-button><i class="fas fa-external-link-alt" aria-hidden="true"></i> Continue in Cortex</a>

			<br><br>

		</div><!-- col -->
	</div>
</ng-template>


`, styles: ["a.active { color: #8e7ab8; }"]
})
export class CortexRedirectorComponent {
	@Input() title: string = "";
	@Input() subsampleId: number = -1;
	@Input() employeeId: number = -1;
  @Input() cortexPageAbrev: string = "";
  @Input() buttonOnly: boolean = false;
  @Output() redirected: EventEmitter<boolean> = new EventEmitter<boolean>();
	RedirectorPath: string = "";

	constructor(
		private appSettings: AppSettings,
		private router: Router,
		private miscService: MiscService
	) { }

  redirectToCortex() {
        this.RedirectorPath = StringExtensions.formatByName(this.appSettings.RedirectorPath, {
            "employeeId": this.employeeId,
            "surveyId": this.subsampleId,
            "location": this.cortexPageAbrev,
            "jobId": -1,
            "hash": "not yet computed",
            "notimeout": "yes"
        });

        this.miscService.getRedirectorHashForUrl(this.RedirectorPath).then((hash: string) => {
            this.RedirectorPath = StringExtensions.formatByName(this.appSettings.RedirectorPath, {
                "employeeId": this.employeeId,
                "surveyId": this.subsampleId,
                "location": this.cortexPageAbrev,
                "jobId": -1,
                "hash": hash,
                "notimeout": "yes"
            });
            this.goToCortex();
        }, () => {});
    };

    private goToCortex() {
        if (this.subsampleId != -1 && this.RedirectorPath != "") {
            if (this.employeeId != 0) {
                let win = `//${Location.host}/#/${AppRoutes.detour.path}/${AppRoutes.detour.cortex.path}?` +
                    StringExtensions.jsonQueryString({
                        "CortexRedirectUrl": Location.encode(this.RedirectorPath)
                    });
                this.redirected.emit(true);
                window.open(win);
            }
            else {
                this.redirected.emit(false);
                this.router.navigate([AppRoutes.redirectError.path]);
            }
        }
        else {
            this.redirected.emit(false);
            this.router.navigate([AppRoutes.redirectError.path]);
        }
    };
}
